import { ClickableDiv } from '@wwe-portal/ui/components/button';
import { OfferTimeCountDown } from '../../offer/component/offer-time-countdown';
import { useResponsive } from '@wwe-portal/ui/hooks/use-responsive';
import { cn } from '@wwe-portal/ui/lib/lib';
import milestoneLogo from '@wwe-portal/ui/assets/images/store-revamp/event-trophy.webp';
import rewardIcon from '@wwe-portal/ui/assets/images/store-revamp/icon-reward.webp';
import milestoneBg from '@wwe-portal/ui/assets/images/store-revamp/milestone-bg.webp';

import { ProgressBar } from './progress-bar';

export interface MilestoneItemProps {
  eventId: string;
  milestoneId: string;
  title: string;
  currentProgress: number;
  totalProgress: number;
  level: number | undefined;
  totalRewards: number | undefined;
  endDate: string;
}
export function MilestoneItem({
  milestone,
  isCarousel,
  onClickDetails,
}: Readonly<{
  milestone: MilestoneItemProps;
  isCarousel?: boolean;
  onClickDetails?: () => void;
}>) {
  const { isMobile } = useResponsive();
  return (
    <div
      className="relative h-[54px] w-full"
      data-milestone={milestone.milestoneId}
      data-event={milestone.eventId}
    >
      <div className="absolute inset-0 overflow-hidden rounded-md bg-gradient-to-b from-[#A9A9A9] via-[#999999] to-[#C4C4C4]">
        <div className="absolute inset-0.5 overflow-hidden rounded-md">
          <div className="absolute -inset-x-10 -inset-y-4">
            <img
              alt="success"
              className="size-full object-cover"
              src={milestoneBg}
            />
          </div>
        </div>
      </div>
      <div className="absolute inset-y-0 flex w-[60px] items-start justify-center">
        <img alt="success" src={milestoneLogo} />
        <div className="font-poppins absolute top-[13px] inline-block bg-gradient-to-r from-[#ffa800] to-[#ffe432] bg-clip-text text-[13px] font-bold text-transparent">
          {milestone.level ?? 0}
        </div>
      </div>
      <div className="absolute inset-y-0 left-[60px] right-[40px]">
        <ProgressBar
          className="w-full"
          currentProgress={milestone.currentProgress}
          percent={
            milestone.totalProgress
              ? (milestone.currentProgress * 100) / milestone.totalProgress
              : 0
          }
          title={milestone.title}
          totalProgress={milestone.totalProgress}
        />
      </div>
      {Boolean(milestone.totalRewards) && (
        <ClickableDiv
          className={cn(
            'absolute right-2 top-0 flex w-[40px] flex-col items-center justify-center',
            {
              'right-4': !isCarousel && !isMobile,
              'right-9': isCarousel && !isMobile,
            }
          )}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            onClickDetails?.();
          }}
        >
          <img alt="success" className="object-cover" src={rewardIcon} />

          <span className="relative -top-[4px]">x{milestone.totalRewards}</span>
        </ClickableDiv>
      )}
      {milestone.endDate ? (
        <div className="absolute -top-4 left-0 text-[11px] font-semibold">
          <OfferTimeCountDown
            endDate={new Date(milestone.endDate)}
            endTimeString="0h0ms"
          />
        </div>
      ) : null}
    </div>
  );
}
